import { getNegationPrefix } from '../common/negatable.js';
import { getOperatorSymbol, } from '../common/operator.js';
export function buildStringFacetField(config) {
    return {
        toQuerySyntax() {
            const prefix = getNegationPrefix(config);
            const { field, operator, value } = config;
            const symbol = getOperatorSymbol(operator);
            const formattedValue = operator === 'fuzzyMatch'
                ? ` $quoteVar(value: ${value})`
                : `("${value}")`;
            return `${prefix}@${field}${symbol}${formattedValue}`;
        },
    };
}
